import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-e4253fa6")

_pushScopeId("data-v-e4253fa6")
const _hoisted_1 = { class: "example-page container" }
const _hoisted_2 = { class: "example-page-header" }
const _hoisted_3 = { class: "example-page-header-toFixed" }
const _hoisted_4 = { class: "example-page-list-item-image" }
const _hoisted_5 = { class: "example-page-list-item-text" }
const _hoisted_6 = { class: "example-page-list-item-text-title" }
const _hoisted_7 = { class: "example-page-list-item-text-article" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tabList, (item, i) => {
          return (_openBlock(), _createBlock("p", {
            key: i,
            onClick: ($event: any) => (_ctx.changeTab(item.value, i)),
            class: ["example-page-header-item", [_ctx.active == i ? 'example-page-header-item-active' : '']]
          }, _toDisplayString(item.label), 11, ["onClick"]))
        }), 128))
      ])
    ]),
    _createVNode(_component_el_row, { class: "example-page-list" }, {
      default: _withId(() => [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.list, (item, i) => {
          return (_openBlock(), _createBlock("div", {
            class: "example-page-list-item",
            key: i
          }, [
            _createVNode("div", _hoisted_4, [
              _createVNode("img", {
                src: item.image,
                alt: ""
              }, null, 8, ["src"])
            ]),
            _createVNode("div", _hoisted_5, [
              _createVNode("p", _hoisted_6, _toDisplayString(item.title), 1),
              _createVNode("p", _hoisted_7, _toDisplayString(item.description), 1)
            ])
          ]))
        }), 128))
      ]),
      _: 1
    })
  ]))
})